import React from "react";
import { Skeleton } from "@mui/lab";

export const TaskTableSkeleton: React.FC = () => {
    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
            {/* Table Header Skeleton */}
            <div className="bg-gray-50 border-b border-gray-200 px-4 py-3 hidden md:block">
                <div className="flex items-center gap-4">
                    <Skeleton variant="text" width={150} height={20} />
                    <Skeleton variant="text" width={100} height={20} />
                    <Skeleton variant="text" width={150} height={20} />
                    <Skeleton variant="text" width={120} height={20} />
                    <Skeleton variant="text" width={200} height={20} className="flex-1" />
                </div>
            </div>

            {/* Table Rows Skeleton */}
            <div className="divide-y divide-gray-100">
                {Array.from({ length: 8 }, (_, i) => (
                    <div key={i} className="px-4 py-4 hover:bg-gray-50 transition-colors">
                        <div className="flex items-center gap-2 md:gap-4 flex-wrap md:flex-nowrap">
                            {/* Task Name */}
                            <div className="flex-1 min-w-[200px] space-y-1">
                                <Skeleton variant="text" width="80%" height={20} />
                                <Skeleton variant="text" width="60%" height={16} />
                            </div>

                            {/* Region */}
                            <div className="w-full md:w-auto">
                                <Skeleton variant="text" width={100} height={18} />
                            </div>

                            {/* Assigned To */}
                            <div className="hidden md:flex items-center gap-2">
                                <Skeleton variant="circular" width={20} height={20} />
                                <div className="space-y-1">
                                    <Skeleton variant="text" width={100} height={18} />
                                    <Skeleton variant="text" width={80} height={14} />
                                </div>
                            </div>

                            {/* Interviews Count */}
                            <div className="hidden md:block">
                                <Skeleton variant="text" width={60} height={18} />
                            </div>

                            {/* Progress */}
                            <div className="hidden md:block flex-1 space-y-2">
                                <Skeleton variant="rectangular" width="100%" height={8} className="rounded-full" />
                                <Skeleton variant="rectangular" width="80%" height={8} className="rounded-full" />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

